import styled from 'styled-components';

import themeSpacing from '@polyai/ui/styles/config/spacing';

export const Wrapper = styled.div<{ $audioWrapperHeight?: number }>`
  position: fixed;
  z-index: 20;
  right: ${themeSpacing.sm3};
  bottom: ${({ $audioWrapperHeight = 0 }) =>
    $audioWrapperHeight > 0
      ? `${$audioWrapperHeight + 24}px`
      : themeSpacing.sm3};

  transition: all 0.3s ease-out;
`;

export const Iframe = styled.iframe`
  position: absolute;
  right: 0;
  bottom: 0;
  transform-origin: bottom right;
  transform: scale(0.9);

  background-color: transparent;
  border: none;
`;
